module.exports = __webpack_public_path__ + "images/laptop.25fc8e2d9d06b3f70e74e7ac96794b8b.jpg";